!function($, window, document) {
    $(window), $(document), $(document.body);
    $(".js-anchor").on("click", (function(e) {
        e.preventDefault();
        var target = $(this).attr("href"), offset = $(target).offset().top;
        $("html").animate({
            scrollTop: offset
        }, 200);
    })), $(window).on("load resize", (function() {
        let headerHeight = $(".header").outerHeight(), footerHeight = $(".footer").outerHeight();
        $("body").css({
            "--header-height": headerHeight + "px",
            "--footer-height": footerHeight + "px"
        });
        let $section_text = $(".section-media+.section-text");
        if ($section_text.length > 0) {
            let $section_media = $section_text.prev(".section-media"), heroHeaderHeight = $section_media.find(".section-media__head").outerHeight(), heroFooterHeight = $section_text.find(".section-text__head").outerHeight();
            $section_media.css({
                "--hero-header-height": heroHeaderHeight + "px",
                "--hero-footer-height": heroFooterHeight + "px"
            });
        }
    }));
    $(".js-skip-animation").on("click", (() => {
        localStorage.setItem("skip-animation", "true");
    }));
    $(window).on("load", (function() {
        (() => {
            const shouldSkipAnimation = localStorage.getItem("skip-animation");
            return localStorage.removeItem("skip-animation"), shouldSkipAnimation;
        })() ? $("html").addClass("skip-animation") : $(".js-load-animation").length ? ($("html").addClass("animate"), 
        setTimeout((function() {
            $("html").addClass("loaded");
        }), 4e3)) : $("html").addClass("loaded");
    }));
}(jQuery, window, document);